// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__khU-i","cell":"ColumnAccessor_cell__3GD9C","firstCellAccent":"ColumnAccessor_firstCellAccent__2Lr73"};